import { useParams, Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/news';

export default function RelatedArticles() {
  const { id } = useParams<{ id: string }>();
  const current = newsArticles.find((a) => a.id === id);

  const related = newsArticles
    .filter((a) => a.id !== id && a.categorySlug === current?.categorySlug)
    .slice(0, 4);

  if (related.length === 0) return null;

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10">
          相关爆料
        </h2>

        <div className="flex gap-5 overflow-x-auto pb-2 max-w-6xl mx-auto">
          {related.map((article) => (
            <Link
              key={article.id}
              to={`/detail/${article.id}`}
              className="group flex-shrink-0 w-[280px] md:w-[300px] bg-background-50 border border-foreground-200/15 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-500/40 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - 51黑料吃瓜网`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-bold text-foreground-800 text-sm leading-snug group-hover:text-primary-400 transition-colors duration-300 line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <span className="text-foreground-400 text-xs">{article.date}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}